export default "__VITE_ASSET__C_jyp2Yd__"